require('./sctAdmin.scss');

const sctAdmin = angular.module('app.sct.sctAdmin', [
  'as.sortable',
  require('../../lbNav').name,
  require('./sctAdminNav/sctAdminNav').name,
  require('../sctTabs/sctTabs').name
]);

sctAdmin.component('sctAdmin', {
  controller: ['$state', '$rootScope', 'sctUserPermissionsService', sctAdminCtrl],
  controllerAs: 'vm',
  template: require('./sctAdmin.html')
});

function sctAdminCtrl($state, $rootScope, sctUserPermissionsService) {
  let vm = this;
  vm.$state = $state;
  vm.userPermission = sctUserPermissionsService.permissions;
  vm.openNav = false;
}

export default sctAdmin;


// WEBPACK FOOTER //
// ./src/components/sct/sctAdmin/sctAdmin.js